import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import UnmatchedDocumentsResult from "../model/UnmatchedDocumentsResult";

interface UnmatchedDocumentsRequest {
  id: number;
  search?: string;
}

const UnmatchedDocumentDetailsApiService = async (
  request: UnmatchedDocumentsRequest
): Promise<UnmatchedDocumentsResult> => {
  const searchParam =
    request.search && request.search?.trim().length > 0
      ? `?search=${request.search}`
      : "";
  const url = `/document_processing_jobs/${request.id}/unmatched_documents${searchParam}`;

  const { data } = await axios.get(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useUnmatchedDocumentDetailsApiService = (
  request: UnmatchedDocumentsRequest
) =>
  useQuery<
    Promise<UnmatchedDocumentsResult>,
    AxiosError,
    UnmatchedDocumentsResult
  >(["DocumentUploadDetailsApiService", request], () =>
    UnmatchedDocumentDetailsApiService(request)
  );

export default useUnmatchedDocumentDetailsApiService;
